<div class="modal-header">
  <h4
    class="modal-title pull-left"
    i18n="@@disclaimer-title"
  >Disclaimer</h4>
</div>
<div class="modal-body">
  <markdown [data]="this.text"></markdown>
  <hr>
  <div class="row">
    <div class="col">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="dontShowAgain"
          id="flexCheckDefault"
        >
        <label
          class="form-check-label"
          i18n="@@disclaimer-dont-show-again"
          for="flexCheckDefault"
        >
          Nicht mehr anzeigen
        </label>
      </div>
    </div>
    <div class="col-auto">
      <div
        class="btn btn-primary"
        i18n="@@confirm"
        (click)="bsModalRef.hide()"
      >Verstanden</div>
    </div>
  </div>
</div>